<template>
  <div class="v-input">
    <input :type="type" @input="input" :placeholder="placeholder" v-model="content" @blur="blur" @focus="focus"/>
    <i @mousedown.stop="mousedown($event)" class="iconfont icon-del" v-if="content&&isFocus"></i>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: '',
      isFocus: false
    }
  },
  mounted() {
    // console.log(this)
    this.content = this.value
  },
  methods: {
    input() {
      this.$emit('input', this.content)
    },
    blur() {
      this.isFocus = false
      this.$emit('blur')
    },
    focus() {
      this.isFocus = true
      this.$emit('focus')
    },
    mousedown(e) {
      e.preventDefault()
      this.content = ''
      this.input()
    }
  },
  watch: {
    value(nv) {
      this.content = nv
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .v-input{
    position: relative;
    z-index: 1;
    .iconfont{
      position: absolute;
      z-index: 2;
      top: 50%;
      right: 0;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      font-size: size(30);
      color: #999;
    }
    input{
      color: #333;
      font-size: size(28);
      padding-right: size(32);
      &::placeholder{
        color: #999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/input.vue